export const isCSSVariableSet = (variable: string): boolean => {
    const value: string = getComputedStyle(document.body).getPropertyValue(variable);
    /* There can be extra spaces in variable value */
    return !!value && !value.includes('none');
};
